import { connect } from 'react-redux'
import { PRODUCT_FILTERS_UPDATED, PRODUCT_FILTERS_CLEARED } from './actions'

export const productFiltersReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_FILTERS_UPDATED:
    case PRODUCT_FILTERS_CLEARED:
      return { ...state, ...action.filters }
    default:
      return state
  }
}

export const withActiveProductFilters = () => {
  const WithActiveProductFilters = (WrappedComponent) =>
    connect((state, ownProps) => ({
      productFilters: state.productFilters,
      ...ownProps,
    }))(WrappedComponent)

  return WithActiveProductFilters
}
